var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 50,
    viewBox: "0 0 125 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    width: 50,
    height: 50,
    fill: "#FAB39D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 50C63.8071 50 75 38.8071 75 25C75 11.1929 63.8071 0 50 0C36.1929 0 25 11.1929 25 25C25 38.8071 36.1929 50 50 50Z",
    fill: "#4EB072"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25C25 38.8066 13.8066 50 0 50L0 0C13.8066 0 25 11.1934 25 25Z",
    fill: "#0999B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/I3.01f95ed387f54c028141c1975498aa7f.svg";
export { ForwardRef as ReactComponent };